import { v4 as uuidv4 } from 'uuid'

const DEFAULT_TOAST_OPTIONS = {
  hasOverlay: false,
  isLoading: false,
  isDisappearing: true,
}

const state = {
  toastMessages: [],
}

const getters = {
  toastMessages: (state) => {
    return state.toastMessages || []
  },
  hasOverlay: (state) => {
    return state.toastMessages.some((toast) => toast.options?.hasOverlay)
  },
}

const mutations = {
  SET_TOAST_MESSAGE(state, { id, toastMessage, toastIcon, options }) {
    state.toastMessages.push({
      id,
      content: toastMessage,
      icon: toastIcon,
      options,
    })
  },
  CLEAR_TOAST_MESSAGE(state, toastMessage) {
    state.toastMessages = state.toastMessages.filter(
      (item) => item?.id !== toastMessage?.id
    )
  },
}

const actions = {
  showToast({ commit }, { message, icon, options }) {
    const toast = {
      id: uuidv4(),
      toastMessage: message,
      toastIcon: icon,
      options: {
        ...DEFAULT_TOAST_OPTIONS,
        ...options,
      },
    }
    commit('SET_TOAST_MESSAGE', toast)
    return toast
  },
  clearToast({ commit }, data) {
    commit('CLEAR_TOAST_MESSAGE', data)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
